import React from "react";
import { Box, Stack, Button, Typography, Divider } from "digiwash-components";
import { formatNumber } from "digiwash-core";
import { Linking } from "react-native";

interface PropsType {
  phone: string;
}

function ContactUs(props: PropsType) {
  return (
    <Box br="s" p="xxl" bg="gray.bg">
      <Stack direction="vertical" distribution="center">
        <Button
          onPress={() => {
            Linking.openURL(`tel:${props.phone}`);
          }}
        >
          ثبت سفارش تلفنی
        </Button>
        <Divider size="m" />
        <Typography color="common.black" ff="mainBold">
          {formatNumber(props.phone)}
        </Typography>
      </Stack>
    </Box>
  );
}

export default ContactUs;
